import { inject } from "@angular/core";
import { filter, tap } from "rxjs";
import { TranslocoService } from "@jsverse/transloco";
import { HttpInterceptorFn, HttpResponse } from "@angular/common/http";

import { ToastService } from "@azm/core/services/toast/toast.service";
import { IApiResponse } from "@azm/core/interfaces/response";

export const successInterceptor: HttpInterceptorFn = (req, next) => {
	const translocoService = inject(TranslocoService);
	const toast = inject(ToastService);

	if (req.headers.get("is-config")) return next(req);

	return next(req).pipe(
		filter((event) => event instanceof HttpResponse),
		tap((event) => {
			if (req.url.includes("refresh-token")) return;

			const response = event.body as IApiResponse<unknown>;
			if (!response) return;
			if (req.headers.get("show-alert") === "false") return;

			const payload = response.data as { isValid?: boolean; responseMessage?: string } | undefined;
			if (response.success && payload && typeof payload === "object" && "isValid" in payload && payload.isValid === false) {
				return;
			}

			const successHeader = req.headers.get("success-alert-message");
			const errorHeader = req.headers.get("error-alert-message");

			const successMessage = successHeader ? translocoService.translate(successHeader) : response.message;
			const errorMessage = errorHeader ? translocoService.translate(errorHeader) : response.message;

			if (response.success || response.statusCode?.toString().startsWith("2")) {
				if (req.method === "GET") return;
				toast.backendSuccess(successMessage?.trim() || "alert.operation_success");
			} else if (!response.success || !response.statusCode?.toString().startsWith("2")) {
				toast.backendError(errorMessage?.trim() || "alert.unhandled_error");
			}
		}),
	);
};
